import React from 'react'

import { Breakpoints, useMediaQuery } from '@pb/utils'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

import { adyenConstants } from '../../constants'
import { getAdyenAction, getAdyenConfig, getAdyenSDKLoaded } from '../../duck/selectors'
import AdyenActionHandler from '../AdyenActionHandler'

const AdyenCheckout: React.FC<any> = ({ onChallengeModalClose }) => {
  const isSmallScreen = useMediaQuery(Breakpoints.MEDIUM)
  const adyenSDKLoaded = useSelector(getAdyenSDKLoaded)
  const action = useSelector(getAdyenAction)
  const config = useSelector(getAdyenConfig)

  const { ADYEN_SDK_CSS_URL, ADYEN_SDK_CSS_HASH } = adyenConstants

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={ADYEN_SDK_CSS_URL}
          integrity={ADYEN_SDK_CSS_HASH}
          crossOrigin="anonymous"
          media="print"
          // @ts-ignore
          onLoad="this.media='all'"
        />
      </Helmet>

      {action && adyenSDKLoaded && (
        <AdyenActionHandler
          onChallengeModalClose={onChallengeModalClose}
          action={action}
          config={config}
          isSmallScreen={isSmallScreen}
        />
      )}
    </>
  )
}

export default AdyenCheckout
